/*
  Script che aggiunge evidenziazione sul radio selezionato nel componente `@payment`
  Modifica fatta da Antonio durante la QA con Marianna il 27/09/2022
*/

$(document).ready(function () {

  var radio = $('.c-payment__list-item input[type="radio"]');

  if (radio.length) {
    radio.change(function () {
      $('.c-payment__list-item').removeClass("is-selected");
      // Aggiunge class 'is-selected' su 'c-payment__list-item'
      $(this).closest('.c-payment__list-item').addClass("is-selected");
    });  
  }

});